import { createResource } from 'react-resource-router';

import { eocUserResource } from '@atlassian/eoc-resources';

import { type ResourceDependencies } from '../../../common/types';
import { getWidgetTimeline } from '../../endpoints/widget-timeline';

export const createUserTimelineResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
) =>
	createResource({
		type: 'userTimelineResource',
		getKey: () => 'userTimelineResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			const data = await dependencies[eocUserResource.type]?.promise;

			// Since depends API types are not exported it's impossible to infer types,
			// thus we have to use casting
			const accountId = (data as any)?.accountId;
			const timezone = (data as any)?.timeZone;

			if (!accountId || !timezone) {
				return null;
			}

			return getWidgetTimeline(accountId);
		},
		isBrowserOnly: true,
		depends: [...(depends ? depends : []), eocUserResource.type],
	});
